// reducer
const initialState = {
  module: [],
}

const SET_CONTEXT = 'moduleContext/SET_CONTEXT'

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_CONTEXT:
      const { module } = action
      return { ...state, module }

    default:
      return state
  }
};

// action creators
export const setContext = ({ module }) => ({
  type: SET_CONTEXT,
  module,
})
